import CustomStepper from "../stapper/CustomStapper";
import StepThree from "../stapper/StepThree";

export function EventDecision() {
    return <CustomStepper step={2}>
        <StepThree/>
    </CustomStepper>
}